import { frontmanZendeskApi, METHOD } from '@/utils/api'

import { TicketField } from './types'

export type GetTicketFieldResponse = {
  ticket_field: TicketField
}

export type GetTicketFieldOption = {
  isProxy?: boolean
  disableAuth?: boolean
}
/** 티켓 필드 조회 API - isProxy일 경우 cache */
export const getTicketField = (name: string, option: GetTicketFieldOption = {}) => {
  return frontmanZendeskApi<GetTicketFieldResponse>({
    path: `api/zendesk/ticket/field/${name}`,
    method: METHOD.GET,
    ...option,
  })
}
